<template>
  <nuttrema-layout-form-standard :edit="true" :saveError="AllergenDetails.saveError" theme="west-top">
    <template slot="center">
      <el-form
         label-position="top"
        :ref="formRef"
        :model="formData"
        :rules="rules"
        :validate-on-rule-change="false">

        <section class="is-have-help">
          <p class="section-title">{{ $t('label.main_information') }}</p>
          <div class="section-items">
            <el-form-item :label="$t('label.name')" prop="name">
              <el-col :span="24">
                <el-input v-model="formData.name"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item
              :label="$t('label.description')"
               prop="description"
               class="el-form-item--remove-line-height">
              <el-col :span="24">
                <el-input
                   class="w-100"
                   type="textarea"
                   v-model="formData.description"
                  :autosize="{ minRows: 3, maxRows: 10 }">
                </el-input>
              </el-col>
            </el-form-item>
          </div>
        </section>

      </el-form>
    </template>

    <template slot="footer">
      <div class="footer-row" v-if="_isEmpty(AllergenDetails.data)">
        <el-button type="primary" size="small" @click="submitForm" :loading="isSaving">{{ $t('label.create') }}</el-button>
        <el-button type="text" size="small" @click="cancelChanges(false)">{{ $t('label.cancel') }}</el-button>
      </div>
      <template v-else>
        <div class="footer-row">
          <permissions-control-wrapper
             action="label.edit"
            :required-general="$PERMISSIONS_GENERAL.EDIT"
            :permissions="_get(AllergenDetails, 'meta.permissions')">
            <div slot="allowed">
              <el-button type="primary" size="small" @click="submitForm" :loading="isSaving">{{ $t('label.save_changes') }}</el-button>
              <el-button type="text" size="small" @click="cancelChanges(false)">{{ $t('label.cancel') }}</el-button>
            </div>
            <div slot="not-allowed"></div>
          </permissions-control-wrapper>

          <permissions-control-wrapper
             action="label.delete"
            :required-general="$PERMISSIONS_GENERAL.DELETE"
            :permissions="_get(AllergenDetails, 'meta.permissions')">
            <div slot="allowed">
              <popover-question-alert
                 buttonTitle="label.delete"
                 buttonType="danger"
                 popoverWidth="280"
                 popoverTitle="label.delete"
                 popoverText="label.delete_sure"
                 popoverPlacement="top-end"
                 buttonSize="small"
                :popoverShouldShow="true"
                @confirmed="onDeleteAllergen">
              </popover-question-alert>
            </div>
            <!-- <div slot="not-allowed"></div> -->
          </permissions-control-wrapper>
        </div>
      </template>
    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
/* eslint-disable object-shorthand */
import { clone, get } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import PopoverQuestionAlert from 'components/ui/alert/nuttrema-popover-question-alert';

export default {
  name: 'form-allergen-cred',
  mixins: [
    FormStandardBehavior,
  ],
  props: {
    AllergenDetails: {
      required: true,
      default: null,
    },
  },
  components: {
    PopoverQuestionAlert,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        name: null,
        description: null,
      },
      rules: {
        name: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.name', true),
          },
        ],
      },
    };
  },
  methods: {
    getFormData() {
      return clone(this.formData);
    },
    setFormData() {
      this.formData.name = get(this.AllergenDetails, 'data.name');
      this.formData.description = get(this.AllergenDetails, 'data.description');
    },
    onDeleteAllergen() {
      this.$emit('deleteAllergen', get(this.AllergenDetails, 'data.id'));
    },
  },
  created() {
    this.formRef = 'cred-allergen';
    this.stateData = this.AllergenDetails;
    this.setFormData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/workspace/allergens/cred-allergen/form-allergen-cred.vue